import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarContextType {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  drawerWidth: number;
  collapsedDrawerWidth: number;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

interface SidebarProviderProps {
  children: ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const drawerWidth = 240;
  const collapsedDrawerWidth = 64;

  return (
    <SidebarContext.Provider value={{ 
      sidebarCollapsed, 
      setSidebarCollapsed, 
      drawerWidth, 
      collapsedDrawerWidth 
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
